import styled from "styled-components";
import theme from "../../theme/theme";

export const ButtonStyle = styled.button`
  display: flex;
  background-color: ${theme.grey};
  color: ${theme.black};
  width: 100%;
  font-size: 1.25em;
  font-weight: bold;
  font-family: Caveat brush;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  border-radius: 10px;
  border: solid 2px ${theme.black};
  cursor: pointer;

  :active {
    transform: translateY(2px);
  }

  ${(props) =>
    props.styleType === "primary"
      ? `
      background: ${theme.grey};
      color: ${theme.black};
      border: 3px solid ${theme.black};
    `
      : ""}

  ${(props) =>
    props.styleType === "secondary"
      ? `
      background: rgba(${theme.white},.25);
      color: ${theme.red};
      border: 3px solid ${theme.red};
    `
      : ""}
`;

export default ButtonStyle;
